import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { CampaignComparisonApiService } from 'src/services/campaignComparisonApi'

// The report. Computed by the server on every read, so this is deliberately not
// cached for long: reopening a comparison should show the mentions that have
// landed since, which is the whole point of computing it live.
const STALE_MS = 30 * 1000

export const useGetCampaignComparisonQuery = (comparisonId?: string) =>
  useQuery({
    enabled: !!comparisonId,
    queryFn: () => CampaignComparisonApiService.getOne(comparisonId as string),
    queryKey: [QueryKey.GET_CAMPAIGN_COMPARISON, comparisonId],
    staleTime: STALE_MS,
  })
